import {Observable} from 'rxjs';
import {LegalEntity,} from '@ms-organization-entities';
import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {PriorityPatchRequest} from '@primatoo-ms-organization';
import {DataProtectionGovernanceService} from '../interface/data-protection-governance-service';
import {ApiClientConfig} from '../api-client-config';
import {ApiClientUtils} from "../../api-client.utils";
import {UserResource} from 'it/primatoo/openapi/api/org/schemas/userresource/UserResource';
import {CreateResponse} from "it/primatoo/openapi/api/common/schemas/CreateResponse";
import {
  GetUserResourceForDetailsResponse
} from "it/primatoo/openapi/api/org/schemas/userresource/GetUserResourceForDetailsResponse";
import {CreateUserResourceRequest} from "it/primatoo/openapi/api/org/schemas/userresource/CreateUserResourceRequest";
import {
  ListUserResourceForMenuResponse
} from "it/primatoo/openapi/api/org/schemas/userresource/ListUserResourceForMenuResponse";
import {UpdateUserResourceRequest} from "it/primatoo/openapi/api/org/schemas/userresource/UpdateUserResourceRequest";
import {ColumnWithLocalization} from "it/primatoo/openapi/api/org/schemas/common/ColumnWithLocalization";

@Injectable({
  providedIn: 'root'
})
export class UsersResourcesService extends DataProtectionGovernanceService {

  private readonly endpoint: string;
  private readonly endpointV2: string;

  constructor(
    @Inject(ApiClientConfig) private config: ApiClientConfig,
    public httpClient: HttpClient) {
    super(httpClient);
    this.endpoint = this.config.endPoint + '/api/org/user-resources/';
    this.endpointV2 = this.config.endPoint + '/api/org/v2/user-resources/';
  }

  // V2

  public getSystemUsersResourcesForMenu(): Observable<ListUserResourceForMenuResponse> {
    const url = this.endpointV2 + 'system-admin/menu/';
    return this.httpClient.get<ListUserResourceForMenuResponse>(url);
  }

  public updateUsersResources(id: number, requestBody: UpdateUserResourceRequest): Observable<void> {
    const url = this.endpointV2 + id + '/';
    return this.httpClient.put<void>(url, requestBody);
  }

  public getUserResourceDetails(id: number): Observable<GetUserResourceForDetailsResponse> {
    const url = this.endpointV2 + id + '/details';
    return this.httpClient.get<GetUserResourceForDetailsResponse>(url);
  }

  public createUserResource(requestBody: CreateUserResourceRequest): Observable<CreateResponse> {
    const url = this.endpointV2;
    return this.httpClient.post<CreateResponse>(url, requestBody);
  }

  // API V1
  public findUserColumns(): Observable<ColumnWithLocalization[]> {
    const url = this.endpoint + `columns`;
    return this.httpClient.get<ColumnWithLocalization[]>(url);
  }

  setPriority(id: number, request: PriorityPatchRequest): Observable<UserResource> {
    const url = `${this.endpoint}${id}/priority`;
    return this.httpClient.patch<UserResource>(url, request);
  }

  public getUsersResources(selectedLegalEntities?: LegalEntity[]): Observable<UserResource[]> {
    let url = this.endpoint;
    if (selectedLegalEntities?.length > 0) {
      url += `?q=${ApiClientUtils.buildLegalEntitiesFilter(selectedLegalEntities)}`;
    }
    return this.httpClient.get<UserResource[]>(url);
  }

  public getUsersResourcesAuthorized(): Observable<UserResource[]> {
    const url = this.endpoint + 'privacy-role/authorized/';
    return this.httpClient.get<UserResource[]>(url);
  }

  public getUsersResourcesSystemAdmin(): Observable<UserResource[]> {
    const url = this.endpoint + 'privacy-role/system-admin/';
    return this.httpClient.get<UserResource[]>(url);
  }


  public getUserResourceById(id: number): Observable<UserResource> {
    const url = this.endpoint + id + '/';
    return this.httpClient.get<UserResource>(url);
  }

  getEndPointV1(): string {
    return this.endpoint;
  }

  exportRaw() {
    const url = this.endpoint + `download`;
    return this.httpClient.get(url, {
      responseType: 'blob',
      observe: 'response'
    });
  }
}
